<template>
    <div class="lni-c-spinner">
        <svg class="lni-c-spinner__image" viewBox="-20 -20 140 140" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="0" r="6" />
            <circle cx="84.5" cy="15.5" r="6"/>
            <circle cx="100" cy="50" r="6"/>
            <circle cx="84.5" cy=84.5 r="6"/>
            <circle cx="50" cy="100" r="6"/>
            <circle cx="15.5" cy="84.5" r="6"/>
            <circle cx="0" cy="50" r="6"/>
            <circle cx="15.5" cy="15.5" r="6"/>
        </svg>
        <span class="lni-c-spinner__text">Loading...</span>
    </div>
</template>


<script>
import framework from '../../framework';
/**
 *  The x-spinner component.
 *  @module components/x-spinner
 */


/**
 * The x-spinner
 */
export default {
    name: 'x-spinner',
    mixins: [
        framework.mixins.abstractElement,
    ],
};

</script>

<style lang="scss">
@import
    "../../styles/settings.scss",
    "spinner.scss";
</style>



// WEBPACK FOOTER //
// source/components/x-spinner/x-spinner.vue